import { useState } from "react";
import { copyText, dmLink } from "@/lib/copy";
import { Attendance } from "@/components/nobo/Attendance";
import { SUBJECT } from "@/components/nobo/InviteDraft";

const PACE = { chatty: "chatty pace", steady: "steady", quick: "quick-ish", coffee: "post-run coffee" };
const fmt = (iso) => new Date(iso).toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
export const REGULAR_AT = 3;

const Draft = ({ s, kind, onUndo }) => {
  const [copied, setCopied] = useState(false);
  const text = s[`${kind}_draft`];
  const copy = async () => { await copyText(text); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  const link = dmLink(s.contact, text, SUBJECT[kind]);
  return (
    <div className="org-draft" data-testid={`saved-${kind}-${s.id}`}>
      {kind === "nudge" && <span className="draft-label">missed-you note</span>}
      <p>{text}</p>
      <div className="draft-actions">
        <button type="button" className="go small" onClick={copy} data-testid={`saved-${kind}-copy-${s.id}`}>{copied ? "copied" : "copy message"}</button>
        {link && <a className="pill dark" href={link} target="_blank" rel="noopener noreferrer" onClick={copy} data-testid={`saved-${kind}-dm-${s.id}`}>{link.startsWith("mailto") ? "open email" : "copy & open DM"}</a>}
        <button type="button" className="pill dark" onClick={onUndo} data-testid={`undo-${kind}-${s.id}`}>back to waitlist</button>
      </div>
    </div>
  );
};

const Runs = ({ s }) => {
  const n = s.attended_count || 0;
  if (n >= REGULAR_AT) return <span className="regular" data-testid={`regular-badge-${s.id}`}>regular · {n} runs</span>;
  if (n > 0) return <span className="runs-count" data-testid={`runs-count-${s.id}`}>ran {n}x</span>;
  return null;
};

export const SignupCard = ({ s, picked, onToggle, onUndo, onStatus, onAttended }) => (
  <li className={`org-item ${picked ? "picked" : ""} ${(s.attended_count || 0) >= REGULAR_AT ? "is-regular" : ""}`} data-testid={`signup-${s.id}`}>
    <div className="org-head">
      <label className="org-check">
        <input type="checkbox" checked={picked} onChange={onToggle} data-testid={`pick-${s.id}`} />
        <strong>{s.name}</strong>
      </label>
      <span className="org-pace">{PACE[s.pace] || s.pace}</span>
    </div>
    <Runs s={s} />
    <p className="org-contact">{s.contact}</p>
    {s.why && <p className="org-why">"{s.why}"</p>}
    {s.invite_draft && s.status === "invited" && <Draft s={s} kind="invite" onUndo={onUndo} />}
    {s.nudge_draft && s.status === "no_show" && <Draft s={s} kind="nudge" onUndo={onUndo} />}
    {s.status && s.status !== "waitlisted" && <Attendance s={s} onStatus={onStatus} onAttended={onAttended} />}
    <div className="org-meta">
      <span>{fmt(s.created_at)}</span>
      <span className={s.sheet_status === "sent" ? "org-ok" : "org-wait"}>
        {s.sheet_status === "sent" ? "in Google Sheet" : "not in sheet yet"}
      </span>
    </div>
  </li>
);
